export function getNavigationItemTarget(item: TNavigationItem): '_self' | '_blank' {
    if (item.link_type === 'internal') {
        return item.open_in_same_tab === false ? '_blank' : '_self';
    }

    return item.open_in_same_tab_external === true ? '_self' : '_blank';
}
